<div class="container">
  <jmkw-checkboxes
    [checkboxNodeMap]="checkboxNodeMap()"
    (nodeChanged)="handleCheckboxChange($event)"
    [automationKey]="automationKey"
  ></jmkw-checkboxes>
</div>
